import React from 'react';
import { useAmp } from 'next/amp';
import withPageQuery from 'lib/withPageQuery';
import withAds from 'lib/withAds';
import withFlowLayout from 'lib/withFlowLayout';
import AmpPostLayout from 'components/AmpPostLayout';
import PostLayout from 'components/PostLayout';
import { POST } from 'constants/pageTypes';

export const config = { amp: 'hybrid' };

const SitePage = withPageQuery(withAds(withFlowLayout(PostLayout)), {
  type: POST,
  limit: 1 // Fetch post only (recirc is handled by LI)
});

const AmpPage = withPageQuery(withAds(AmpPostLayout), {
  type: POST,
  limit: 2 // Fetch post and recirc (this recirc is deprecated)
});

function Page(props) {
  const isAmp = useAmp();
  if (isAmp) {
    return <AmpPage {...props} />;
  }
  return <SitePage {...props} />;
}

export default Page;
